<script setup lang="ts">
    import { useClientStore } from '@/store/client.store';
    import { storeToRefs } from 'pinia';

    defineProps<{ size?: 'lg' | 'sm' }>();

    const { theme } = storeToRefs(useClientStore());
</script>

<template>
    <div class="flex items-center gap-2.5">
        <img
            :src="theme.logoUrl"
            alt=""
            :class="size === 'lg' ? 'h-12 w-auto' : 'h-9 w-auto'"
        />
        <span
            v-if="theme.slug === 'default'"
            :class="size === 'lg' ? 'text-xl font-bold text-gray-900' : 'text-sm font-bold text-gray-900'"
        >
            {{ theme.name }}
        </span>
    </div>
</template>
